module.exports = __webpack_public_path__ + "img/udmark-dark.ae882c49.png";